module.exports = __webpack_public_path__ + "img/bg_function06_3_d.8372d6c8.svg";